// Text1.js – Abschnitt der Startseite mit Text und Bildkarussell (Daten in carouselData, Slides über CarouselSlide).
import "./Home.css";
import "./custom.css";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";

import Buehne from "./images/Arbeiten/verkehrssicherung-buehne.webp";
import Klettertechnik from "./images/Arbeiten/Klettertechnik.webp";
import Gefahrenfaellung from "./images/Arbeiten/gefahrenfaellung-buehne.webp";
import Schreddertechnik from "./images/Arbeiten/Schreddertechnik.webp";
import Haecksler from "./images/Arbeiten/unimog-haecksler.webp";

import CarouselSlide from "./CarouselSlide";
import { karussellIntervall } from "../../reducedMotion";

const carouselData = [
  {
    image: Buehne,
    width: 1200,
    height: 675,
    title: "Baumschnitt und Fällungen",
    description: "Ob Verkehrssicherung, Baumschnitt oder Fällungen: Mit der Arbeitsbühne arbeiten unsere Baumpfleger effizient und sicher.",
    alt: "Baumpfleger in orangefarbener Warnkleidung im Korb einer Hubarbeitsbühne an einer kahlen Eiche vor blauem Himmel",
  },
  {
    image: Klettertechnik,
    width: 660,
    height: 371,
    title: "Baumkletterer mit Seiltechnik",
    description: "Mit der Seiltechnik können wir auch in schwierigen Lagen Baumfällungen oder den Baumschnitt durchführen.",
    alt: "Baumkletterer mit Helm und Klettergurt in einem bereits teilweise entasteten Baum",
  },
  {
    image: Gefahrenfaellung,
    width: 1200,
    height: 675,
    title: "Not- und Gefahrenfällung",
    description: "Steht der Baum nah am Gebäude oder an der Straße, tragen wir ihn von der Bühne oder mit Seilklettertechnik Stück für Stück ab.",
    alt: "Hubarbeitsbühne mit Baumpfleger im Korb hoch zwischen kahlen Laubbäumen vor blauem Himmel",
  },
  {
    image: Haecksler,
    width: 1200,
    height: 675,
    title: "Mit dem Unimog auch im Gelände",
    description: "Mit dem Unimog können wir auch in unwegsamem Gelände effizient arbeiten.",
    alt: "Grüner Unimog mit Holzhäcksler an der Front und Seilwinde am Heck vor kahlen Bäumen bei Sonnenschein",
  },
  {
    image: Schreddertechnik,
    width: 660,
    height: 371,
    title: "Abtransport von Grüngut",
    description: "Geschreddert oder im Stück: Wir transportieren das Grüngut ab und entsorgen es fachgerecht.",
    alt: "Unimog 406 mit Pritsche und angehängtem Häcksler neben einem Haufen Hackschnitzel",
  },
];

function Text1() {
  return (
    <div style={{ background: "var(--ff-forest)" }}>
      <Container className="py-5">
        <div className="mb-4">
          <span className="ff-eyebrow">Baumpflege &amp; Forstarbeiten</span>
          <h2 className="ff-section-title">
            Kompetenz für<br />Baum &amp; Fläche
          </h2>
        </div>
        <Row className="align-items-center py-3 gy-4">
          <Col xs={12} md={6} className="text-white">
            <p style={{ fontSize: "1.05rem", lineHeight: 1.75, color: "rgba(238,244,234,.88)" }}>
              Wir sind Ihr Ansprechpartner in Schleswig-Holstein für alle Themen rund um
              Baumfällung, Baumschnitt und Landschaftspflege. Unsere Baumkletterer
              und Baumpfleger sind durch die Verwendung von Kletter- und Seiltechnik sowie
              Arbeitsbühnen auch für anspruchsvolle Aufgaben bestens gerüstet.
            </p>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.75, color: "rgba(238,244,234,.88)", marginTop: "1rem" }}>
              Bei Not- und Gefahrenfällungen erreichen Sie uns am schnellsten telefonisch.
              Hier kommt oft unsere Seilwinde unterstützend zum Einsatz.
            </p>
            <div className="mt-4 d-flex gap-3 flex-wrap">
              <Link to="/kontakt" className="btn-ff-primary" onClick={() => window.scrollTo(0, 0)}>
                Kontaktieren Sie uns
              </Link>
              <Link to="/baumpflege" className="btn-ff-outline" onClick={() => window.scrollTo(0, 0)}>
                Mehr zur Baumpflege
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} className="d-flex justify-content-center" style={{ minHeight: "300px" }}>
            <Carousel
              className="w-100"
              interval={karussellIntervall(5000)}
              prevLabel="Vorherige Folie"
              nextLabel="Nächste Folie"
              indicatorLabels={carouselData.map((_, i) => `Folie ${i + 1}`)}
            >
              {carouselData.map((slide, index) => (
                <Carousel.Item key={index}>
                  <CarouselSlide {...slide} />
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Text1;
